import "./style.scss";

import type { TextFieldProps } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useIsMobile } from "hooks/useIsMobile";
import type { ReactElement } from "react";

import { displayMobileNavBtn } from "../BPMobileNavBtn";
import { StyledDatePicker } from "../StyledDatePicker";

interface IYearDatePicker {
    label: string;
    renderInput: (params: TextFieldProps) => ReactElement;
    date: Date | null;
    minDate: number;
    maxDate?: Date;
    onChange: (newValue: any) => void;
}

const YearDatePicker = ({ label, renderInput, date, minDate, maxDate, onChange }: IYearDatePicker) => {
    const { isMobile } = useIsMobile();

    return (
        <div className="filter-datepicker">
            <label htmlFor="">{label}</label>
            <StyledDatePicker
                onOpen={() => isMobile && displayMobileNavBtn(false)}
                onClose={() => isMobile && displayMobileNavBtn(true)}
                className="year-date-picker"
                views={["year"]}
                inputFormat="yyyy"
                value={date}
                minDate={minDate}
                maxDate={maxDate}
                onChange={onChange}
                renderInput={renderInput}
            />
        </div>
    );
};

export default YearDatePicker;
